import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import SectionWrapper from "../../sectionwrapper.component.jsx";

class ProjectTitleContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12">
                    <h2 style={{color: this.state.variables.global.secondaryColor}}>
                        {this.state.variables.project.title}
                    </h2>
                </div>

            </SectionWrapper>
        );
    }
}

export default ProjectTitleContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/project-title/section.component.jsx